import makeStyles from "@mui/styles/makeStyles";
import { FontFamilySwitch } from "../../utils";
export const useStyles = makeStyles((theme) => ({
    box: {
        border: "2px solid white",
        borderRadius: theme.palette.borderRadius,
        boxShadow: "0px 0px 16px #00000014",
        backgroundColor: "white",
        padding: "12px"
    },
    root: {
        padding: "20px",
        height: `calc(100vh - 135px)`,
        overflow: "auto"
    },
    cards: {
        border: "2px solid white",
        borderRadius: theme.palette.borderRadius,
        boxShadow: "0px 0px 16px #00000014",
        backgroundColor: "white",
    },
    unitImg: {
        height: "120px",
        width: "120px",
        borderRadius: "50%",
        margin: "4px",
        objectFit: "fill"
    },
    imgTag: {
        padding: "2px 6px",
        borderRadius: "5px",
        backgroundColor: "#071741",
        color: "white",
        fontSize:"0.75rem",
        fontFamily: FontFamilySwitch().semiBold,
        position: "absolute",
        bottom: "10px",
        display: "inline",

    },
    imgDiv: {
        display: "flex",
        justifyContent: "center",
        position: "relative",
        borderRight: "1px solid #00000014",
        padding: "4px",
    },
    title: {
        color: theme.typography.color.secondary,
        fontSize:"0.75rem",
        fontFamily: FontFamilySwitch().bold
    },
    imgDiv2: {
        padding: "0px 12px"
    },
    heading: {
        color: theme.typography.color.tertiary,
        fontSize:"0.875rem",
        fontFamily: FontFamilySwitch().semiBold,
        textTransform: "capitalize"
    },
    sub: {
        color: theme.typography.color.primary,
        fontSize:"0.875rem",
        fontFamily: FontFamilySwitch().semiBold,
        textTransform: "capitalize",
        "& .ql-editor": {
            padding: "6px 0px",
            textAlign: "start"

        }

    },
    subNo: {
        color: theme.typography.color.primary,
        fontSize:"0.875rem",
        fontFamily: FontFamilySwitch().semiBold,
        textTransform: "capitalize",
        "& .ql-editor": {
            padding: "6px 0px",
            textAlign: "start"

        },
        direction: "ltr",
        textAlign: "end"

    },
    sub1: {
        color: theme.typography.color.primary,
        fontSize:"0.75rem",
        fontFamily: FontFamilySwitch().semiBold,
        textTransform: "capitalize"
    },
    matric: {
        color: theme.typography.color.tertiary,
        fontSize: "0.75rem",
        fontFamily: FontFamilySwitch().regular,
        textTransform: "capitalize"
    },
    map: {
        borderRadius: theme.palette.borderRadius,
        overflow: "hidden",
        height: "200px"

    },
    addressRoot: {
        padding: "12px",
        minHeight: "200px",
        border: "1px solid #E4E8EE",
        borderRadius: theme.palette.borderRadius
    },
    list: {
        '&.MuiListItem-root': {
            width: '135px !important',
            padding: '0px!important',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
            border: '1px solid #E4E8EE',
            cursor: 'pointer',
            marginTop: "-4px"
        }
    },
    tabname: {
        fontSize:"0.75rem",
        fontFamily: FontFamilySwitch().bold,
        cursor: 'pointer'
    },
    imagebox1: {
        padding: '16px',
        backgroundColor: '#fff',
        boxShadow: '0px 0px 16px #00000014',
        borderRadius: '12px',
    },
    imagebox: {
        textAlign: 'center',
        padding: '23px 16px',
        backgroundColor: '#fff',
        boxShadow: '0px 0px 16px #00000014',
        borderRadius: '12px',
    },
    listText: {
        backgroundColor: '#5078E1',
        width: '120px !important',
        color: '#fff',
        borderRadius: '6px',
        textAlign: 'center',
        justifyContent: 'center',
        alignItems: 'center',
        cursor: 'pointer',
        marginTop: "-4px"
    },
    tabtitle: {
        fontSize:"0.75rem",
        color: '#4E5A6B',
        fontFamily: FontFamilySwitch().bold,
    },
    tabtitle1: {
        fontSize:"0.75rem",
        color: '#5078E1',
        fontFamily: FontFamilySwitch().bold,
    },
    subtabtitle: {
        fontSize:"0.75rem",
        color: '#4E5A6B',
        fontFamily: FontFamilySwitch().regular,
    },
    subtabtitle1: {
        fontSize:"0.75rem",
        color: '#5078E1',
        fontFamily: FontFamilySwitch().regular,
    },
    selectBack1: {
        borderTopLeftRadius: "12px",
        borderTopRightRadius: "12px",
        backgroundColor: '#F1F7FF',
        display: 'flex',
        alignItems: 'center',
        padding: '10px 16px',
    },
    selectBack: {
        display: 'flex',
        alignItems: 'center',
        padding: '10px 16px',
    },
    filterButton: {
        border: `1px solid ${theme.palette.border.secondary}`,
        borderRadius: theme.palette.borderRadius,
        padding: "12px"
    },
    nodataText: {
        textAlign: "center",
        marginTop: "10px"
    },
    title2: {
        color: theme.typography.color.secondary,
        fontSize:"0.875rem",
        fontFamily: FontFamilySwitch().bold
    },
}))